import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { CheckCircle2, Download, Mail } from "lucide-react";

const CHECKLIST_URL = "/recursos/checklist-delegar-sin-improvisar.pdf";

function track(event, data = {}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...data });
}

export default function ChecklistGracias() {
  const location = useLocation();
  const name = location.state?.name?.split(" ")[0] || "colega";

  useEffect(() => {
    document.title = "Tu checklist está listo | Colega Link";
    track("checklist_confirmation_view");
  }, []);

  return (
    <main className="min-h-[75vh] bg-gradient-to-br from-slate-950 via-slate-900 to-teal-950 px-5 py-16 text-white">
      <div className="mx-auto max-w-3xl rounded-3xl border border-white/10 bg-white/5 p-7 text-center shadow-2xl backdrop-blur md:p-12">
        <CheckCircle2 className="mx-auto h-16 w-16 text-teal-300" />
        <p className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-teal-300">Solicitud registrada</p>
        <h1 className="mt-3 text-4xl font-black md:text-5xl">Tu checklist está listo, {name}.</h1>
        <p className="mx-auto mt-5 max-w-2xl text-lg leading-8 text-slate-300">Descárgalo ahora. Mientras lo revisas, puedes preparar una gestión indicando tribunal u organismo, ciudad, fecha, tarea y respaldo esperado.</p>
        <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
          <a href={CHECKLIST_URL} download onClick={() => track("checklist_download")} className="inline-flex items-center justify-center gap-2 rounded-xl bg-teal-400 px-6 py-3.5 font-black text-slate-950 hover:bg-teal-300">
            <Download className="h-5 w-5" /> Descargar checklist
          </a>
          <Link to="/registro/abogado?next=/app/delegaciones/nueva&source=checklist_gracias" onClick={() => track("delegar_cta_click", { location: "checklist_thank_you" })} className="inline-flex items-center justify-center rounded-xl border border-white/20 px-6 py-3.5 font-black text-white hover:bg-white/10">
            Publicar mi gestión
          </Link>
        </div>
        <div className="mx-auto mt-9 flex max-w-xl items-start gap-3 rounded-2xl bg-white/5 p-5 text-left text-sm leading-6 text-slate-300">
          <Mail className="mt-0.5 h-5 w-5 shrink-0 text-teal-300" />
          <p>¿Necesitas ayuda para describir el encargo? Escríbenos a <a href="mailto:soporte@colegalink.cl" className="font-bold text-white">soporte@colegalink.cl</a>.</p>
        </div>
      </div>
    </main>
  );
}
